import { render, staticRenderFns } from "./oAuth.vue?vue&type=template&id=d57db704"
import script from "./oAuth.vue?vue&type=script&lang=js"
export * from "./oAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports